// ─────────────────────────────────────────────
//  QRCode — generates a visual QR-like pattern
//  TODO: swap for a real QR library before launch
//  Recommended: npm install qrcode.react
// ─────────────────────────────────────────────

function generateQRPattern(data) {
  const size = 25;
  const seed = data.split("").reduce((a, c) => a + c.charCodeAt(0), 0);
  const grid = [];
  for (let r = 0; r < size; r++) {
    const row = [];
    for (let c = 0; c < size; c++) {
      const inFinder =
        (r < 7 && c < 7) ||
        (r < 7 && c >= size - 7) ||
        (r >= size - 7 && c < 7);
      if (inFinder) {
        const fr = r < 7 ? r : r - (size - 7);
        const fc = c < 7 ? c : c - (size - 7);
        if (r >= size - 7 && c >= size - 7) { row.push(false); continue; }
        row.push(
          fr === 0 || fr === 6 || fc === 0 || fc === 6 ||
          (fr >= 2 && fr <= 4 && fc >= 2 && fc <= 4)
        );
      } else {
        row.push(
          (((seed * (r * 23 + c * 17 + 7)) ^ (r * 31 + c * 13)) % 100) > 45
        );
      }
    }
    grid.push(row);
  }
  return grid;
}

export default function QRCode({ value, size = 160, color = "#1a1a2e", bg = "white" }) {
  const grid = generateQRPattern(value);
  const cellSize = size / grid.length;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <rect width={size} height={size} fill={bg} />
      {grid.map((row, r) =>
        row.map((cell, c) =>
          cell ? (
            <rect
              key={`${r}-${c}`}
              x={c * cellSize + 0.3}
              y={r * cellSize + 0.3}
              width={cellSize - 0.3}
              height={cellSize - 0.3}
              fill={color}
              rx={cellSize * 0.2}
            />
          ) : null
        )
      )}
    </svg>
  );
}
